function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//

/* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */

/**
 * A navigation wrapper component to move through the Select component one item
 * at a time.
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import SvgButton from "../basic/SvgButton";
import Select from "../basic/Select";
import { StyleSheet, css, color, spacing, font, iconSize } from "../../styles/theme";
import { SvgChevronLeft, SvgChevronRight, SvgChevronDown } from "../../svg";
var CONFIG = {
  Select: {
    height: '56px',
    border: "1px solid ".concat(color.divider),
    borderRadius: 0
  },
  MenuContainer: {
    border: 'none',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
    overflow: 'hidden',
    padding: '0 6px'
  },
  NavButton: {
    // custom styles for Button
    Button: {
      ':hover': {
        backgroundColor: color.bgGray,
        borderColor: color.gray
      },
      ':focus': {
        outlineWidth: '2px',
        backgroundColor: color.bgGray
      }
    }
  }
};
var styles = StyleSheet.create({
  container: {
    display: 'flex'
  },
  select: {
    'minWidth': '300px',
    'minHeight': '44px',
    ':hover': {
      backgroundColor: color.bgGray
    }
  },
  customArrow: {
    display: 'flex'
  },
  customValue: {
    position: 'absolute',
    top: '50%',
    left: spacing.md,
    transform: 'translateY(-50%)',
    maxWidth: '86%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: font.md
  }
});

var SelectNavigation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectNavigation, _React$Component);

  function SelectNavigation(props) {
    var _this;

    _classCallCheck(this, SelectNavigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectNavigation).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "defaultProps", void 0);

    _defineProperty(_assertThisInitialized(_this), "getSelectedOption", function () {
      return _this.props.options && _this.props.options[_this.state.selectedIndex];
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (selectedOption, selectedIndex) {
      var onChange = _this.props.onChange; // the forceSelectedIndex prop will override the selectedIndex as long as it is set

      if (typeof _this.props.forceSelectedIndex !== 'number') {
        _this.setState({
          selectedIndex: selectedIndex
        });
      }

      if (onChange) {
        onChange(selectedOption, selectedIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleNavOnClick", function (direction) {
      // direction is 1 for next, -1 for previous
      var newIndex = _this.state.selectedIndex + direction;
      var newOption = _this.props.options[newIndex];

      _this.handleOnChange(newOption, newIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "arrowRenderer", function () {
      return React.createElement("span", css(styles.customArrow), React.createElement(SvgChevronDown, {
        size: iconSize.sm,
        color: color.black
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "valueRenderer", function (option) {
      return React.createElement("p", css(styles.customValue), option.label);
    });

    if (typeof props.forceSelectedIndex === 'number') {
      _this.state = {
        selectedIndex: props.forceSelectedIndex
      };
    } else {
      var selectedIndex = props.startIndex || 0;
      _this.state = {
        selectedIndex: selectedIndex
      };
    }

    return _this;
  }

  _createClass(SelectNavigation, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forceSelectedIndex === 'number' && nextProps.forceSelectedIndex !== this.props.forceSelectedIndex) {
        this.setState({
          selectedIndex: nextProps.forceSelectedIndex
        });
      } else if (nextProps.startIndex !== this.props.startIndex) {
        this.setState({
          selectedIndex: nextProps.startIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          svgPrev = _this$props.svgPrev,
          svgNext = _this$props.svgNext,
          style = _this$props.style,
          menuContainerStyle = _this$props.menuContainerStyle,
          buttonStyle = _this$props.buttonStyle,
          optionHeight = _this$props.optionHeight;
      var selectedIndex = this.state.selectedIndex;
      var selectedOption = this.getSelectedOption();

      if (!options || options.length === 0) {
        return null;
      }

      return React.createElement("div", css(styles.container), React.createElement(SvgButton, {
        size: "sm",
        onClick: function onClick() {
          return _this2.handleNavOnClick(-1);
        },
        disabled: selectedIndex === 0,
        svgElement: svgPrev,
        htmlAttributes: {
          'aria-label': 'Previous'
        },
        customStyles: buttonStyle
      }), React.createElement(Select, _extends({}, css(styles.select), this.props, {
        options: options,
        value: selectedOption,
        optionHeight: optionHeight,
        onChange: this.handleOnChange,
        style: style,
        menuContainerStyle: menuContainerStyle,
        arrowRenderer: this.arrowRenderer,
        valueRenderer: this.valueRenderer,
        htmlAttributes: {
          'aria-label': 'Select menu'
        }
      })), React.createElement(SvgButton, {
        size: "sm",
        onClick: function onClick() {
          return _this2.handleNavOnClick(1);
        },
        disabled: selectedIndex === options.length - 1,
        svgElement: svgNext,
        htmlAttributes: {
          'aria-label': 'Next'
        },
        customStyles: buttonStyle
      }));
    }
  }]);

  return SelectNavigation;
}(React.Component);

_defineProperty(SelectNavigation, "defaultProps", {
  buttonStyle: CONFIG.NavButton,
  menuContainerStyle: CONFIG.MenuContainer,
  optionHeight: 36,
  startIndex: 0,
  style: CONFIG.Select,
  svgNext: React.createElement(SvgChevronRight, {
    color: color.black,
    hoverColor: color.black,
    size: iconSize.sm
  }),
  svgPrev: React.createElement(SvgChevronLeft, {
    color: color.black,
    hoverColor: color.black,
    size: iconSize.sm
  })
});

SelectNavigation.propTypes = {
  buttonStyle: PropTypes.object,
  // Additional control for the root element, can add data-courselenium, ariaLabel...
  htmlAttributes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  // options for Select
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    disabled: PropTypes.bool
  }).isRequired),
  startIndex: PropTypes.number,
  // initial index for value
  // Including the optional forcedSelectedIndex prop turns this uncontrolled component into a controlled component.
  forceSelectedIndex: PropTypes.number,
  style: PropTypes.object,
  svgPrev: PropTypes.node,
  // svg element for previous button
  svgNext: PropTypes.node // svg element for next button
  // More props defined in Select.js

};
export default SelectNavigation;